module.exports = __webpack_public_path__ + "static/media/gal1.2f365509.JPG";